"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var makeSearchAndFilter_1 = __importDefault(require("atomicComponents/organisms/SearchAndFilter/makeSearchAndFilter"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var filter_1 = require("utils/filter");
var useInfiniteScroll_1 = __importDefault(require("utils/hooks/useInfiniteScroll"));
var FooterMaker_1 = __importDefault(require("./FooterMaker"));
var HeaderMaker_1 = __importDefault(require("./HeaderMaker"));
var NoItemsFound_1 = __importDefault(require("./NoItemsFound"));
var RowMaker_1 = __importDefault(require("./RowMaker"));
var makeBatchLoadFilteredTable = function (tableConf, groupDefinitions, fieldsExtractors) {
    var _a;
    var _b = (_a = tableConf.config) !== null && _a !== void 0 ? _a : {}, noFooter = _b.noFooter, selector = _b.selector, defaultSort = _b.defaultSort, batchSize = _b.batchSize;
    if (!selector) {
        throw Error('Unified Table generator requires a selector in table configuration. See TableConf[\'config\']');
    }
    var Header = (0, HeaderMaker_1.default)(tableConf);
    var Row = (0, RowMaker_1.default)(tableConf);
    var Footer = !noFooter && (0, FooterMaker_1.default)(tableConf);
    var useFilterItems = (0, filter_1.makeUseFilterItems)(fieldsExtractors, groupDefinitions);
    var SearchAndFilterComponent = (0, makeSearchAndFilter_1.default)(groupDefinitions);
    var GeneratedTable = function (_a) {
        var _b, _c, _d;
        var filterFunction = _a.filterFunction, toolbarProps = _a.toolbarProps, toolbarContent = _a.toolbarContent, children = _a.children, width = _a.width, props = __rest(_a, ["filterFunction", "toolbarProps", "toolbarContent", "children", "width"]);
        var fullWidth = (_b = tableConf.layout) === null || _b === void 0 ? void 0 : _b.fullWidth;
        var items = (0, react_redux_1.useSelector)(selector);
        var prefilteredItems = (0, react_1.useMemo)(function () { var _a; return (_a = filterFunction === null || filterFunction === void 0 ? void 0 : filterFunction(items)) !== null && _a !== void 0 ? _a : items; }, [items, filterFunction]);
        var _e = __read(useFilterItems(prefilteredItems), 3), filteredItems = _e[0], searchProps = _e[1], filterProps = _e[2];
        var sortedItems = (0, hooks_1.useSortArray)(filteredItems, tableConf.extractors);
        var _f = __read((0, useInfiniteScroll_1.default)(sortedItems || [], batchSize !== null && batchSize !== void 0 ? batchSize : 50), 2), pagedItems = _f[0], loaderRef = _f[1];
        if (!(0, react_redux_firebase_1.isLoaded)(prefilteredItems) || !(0, react_redux_firebase_1.isLoaded)(filteredItems) || !(0, react_redux_firebase_1.isLoaded)(pagedItems)) {
            return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", justifyContent: "flex-end", maxWidth: fullWidth ? undefined : 1400, width: width }, toolbarProps, { children: [toolbarContent === null || toolbarContent === void 0 ? void 0 : toolbarContent.pre, (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "inline-flex" }, { children: (0, jsx_runtime_1.jsx)(SearchAndFilterComponent, __assign({ items: prefilteredItems }, filterProps, searchProps)) })), toolbarContent === null || toolbarContent === void 0 ? void 0 : toolbarContent.post] })), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: fullWidth ? undefined : 1400, width: width }, props, { children: [(0, jsx_runtime_1.jsx)(Header, { count: pagedItems.length, width: fullWidth ? 'min-content' : undefined }), (0, jsx_runtime_1.jsxs)(TableBody_1.default, __assign({ width: fullWidth ? 'min-content' : '100%' }, { children: [pagedItems.map(function (item) { return (0, jsx_runtime_1.jsx)(Row, { item: item }, item.id); }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { height: '1px' }, ref: loaderRef }, { children: ' ' }))] })), !pagedItems.length && (0, jsx_runtime_1.jsx)(NoItemsFound_1.default, { sizing: (_d = (_c = tableConf.row) === null || _c === void 0 ? void 0 : _c.sizing) !== null && _d !== void 0 ? _d : 'regular' }), Footer && (0, jsx_runtime_1.jsx)(Footer, { items: filteredItems, pr: 0, width: fullWidth ? 'min-content' : undefined }), children] }))] }));
    };
    return (0, SortHoC_1.default)(GeneratedTable, defaultSort);
};
exports.default = makeBatchLoadFilteredTable;
